import Button from "components/Button";
import { PHONE } from "constants/at-need";
import { formatPhoneNumber } from "helpers/phone";

export default function ArrangementError() {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="mx-auto flex w-full max-w-lg flex-1 flex-col items-center justify-center px-4 py-16 text-center">
      <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-oat">
        <span className="text-3xl">!</span>
      </div>
      <h1 className="font-serif text-[34px] font-normal leading-[1.15] text-soil">
        Something went wrong
      </h1>
      <p className="mt-3 text-lg text-soil">
        We were unable to load your arrangement details. Please try again or
        contact our care team for assistance.
      </p>
      <div className="mt-8">
        <Button onClick={handleRetry} variant="primary" size="lg">
          Try Again
        </Button>
      </div>
      <p className="mt-6 text-base text-soil">
        Need help? Call us at{" "}
        <a
          href={`tel:${PHONE}`}
          className="font-semibold text-evergreen underline"
        >
          {formatPhoneNumber(PHONE)}
        </a>
      </p>
    </div>
  );
}
